type Args = {
  pathname: string;
  lessenMaintenancePage: string;
  displayMainMaintenanceTracker?: boolean;
  isLessenMaintenanceEnabled?: boolean;
};

const PATH_BOUNDARY = new Set(['/', '?', '#']);

const stripOrigin = (url: string) => url.replace(/^https?:\/\/[^/]+/, '');

/**
 * True when `pathname` is `page` or a route under it. `pathname.includes(page)` is not enough here
 * because the legacy tracker lives at `/rental-manager/maintenance-tasks`, which contains the Lessen
 * page's `/rental-manager/maintenance` as a prefix. Hosts pass either a full href or a bare path as
 * `pathname`, and `page` is absolute when the nav uses absolute paths, so both are compared on their
 * path portion and a segment boundary is required right after the page.
 */
export const isPathAtOrUnder = (pathname: string, page: string) => {
  const pagePath = stripOrigin(page);
  const start = pathname.indexOf(pagePath);
  if (start < 0) {
    return false;
  }
  const next = pathname.charAt(start + pagePath.length);

  return next === '' || PATH_BOUNDARY.has(next);
};

/**
 * Exactly one "Maintenance" item renders. The Lessen pilot item wins over the legacy tracker item,
 * which is a dormant rental-manager-api setting; both are labelled "Maintenance" and would otherwise
 * sit side by side.
 */
export const getMaintenanceNavState = ({
  pathname,
  lessenMaintenancePage,
  displayMainMaintenanceTracker = false,
  isLessenMaintenanceEnabled = false,
}: Args) => ({
  showLessenMaintenance: isLessenMaintenanceEnabled,
  showLegacyMaintenanceTracker: displayMainMaintenanceTracker && !isLessenMaintenanceEnabled,
  isLessenMaintenanceActive: isLessenMaintenanceEnabled && isPathAtOrUnder(pathname, lessenMaintenancePage),
});
